(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  var GAP = 16;

  function initCarousel(section) {
    if (!section || section.dataset.caRecInit === 'true') return;

    var track   = section.querySelector('.ca-rec-track');
    var prevBtn = section.querySelector('.ca-rec-arrow--prev');
    var nextBtn = section.querySelector('.ca-rec-arrow--next');
    if (!track || !prevBtn || !nextBtn) return;

    section.dataset.caRecInit = 'true';

    var currentIndex = 0;

    function cardWidth() {
      var first = track.children[0];
      return first ? first.offsetWidth + GAP : 236;
    }
    function visibleCount() {
      return Math.max(1, Math.floor(track.parentElement.offsetWidth / cardWidth()));
    }
    function maxIndex() {
      return Math.max(0, track.children.length - visibleCount());
    }
    function updateArrows() {
      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = currentIndex >= maxIndex();
    }
    function slideTo(index) {
      currentIndex = Math.max(0, Math.min(index, maxIndex()));
      track.style.transform = 'translateX(-' + (currentIndex * cardWidth()) + 'px)';
      updateArrows();
    }

    prevBtn.addEventListener('click', function () { slideTo(currentIndex - 1); });
    nextBtn.addEventListener('click', function () { slideTo(currentIndex + 1); });
    window.addEventListener('resize', function () { slideTo(currentIndex); });

    updateArrows();
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-ca-rec]');
    for (var i = 0; i < sections.length; i++) {
      initCarousel(sections[i]);
    }
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after the theme's AJAX cart re-render replaces the section HTML.
  // The new DOM has no init flag, so initAll() binds handlers to the fresh arrows.
  document.addEventListener('cart:rerendered', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
